export default __webpack_public_path__ + "media/storefront/img/productsBadges/usa-badge-a7c7d733dcf14ab0930bacaa6cd2d4bc.png";